module.exports = __webpack_public_path__ + "static/img/objetos.3c32a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objetos.png
// module id = rIqf
// module chunks = 0